export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close',
    '_11230_MY_TASKS': 'My Tasks',
    '_9569_TODAY': 'Today',
    '_11231_THIS_WEEK': 'This Week',
    '_11232_FUTURE': 'Future',
    '_7223_COMPLETED': 'Completed',
    '_11233_NEW_TASK_CREATED': 'New Task Created'
};
